import { Fragment, useContext, useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { InfoItemHorizontal } from 'components';
import { DateConvert } from 'utilities';
import { PermintaanBahanProduksiApi } from 'api';
import { TableTransferBahanProduksi } from '../TableTransferBahanProduksi';
import { TablePermintaanFS } from './TablePermintaanFS';
import { TransferBahanProduksiContext } from '../../Context';

export const TabFactorySupply = () => {
  const { dataJobOrder, dataPermintaan } = useContext(
    TransferBahanProduksiContext
  );
  const id_permintaan_produksi = dataJobOrder.id_permintaan_produksi;
  const [history, setHistory] = useState([]);

  // FETCH HISTORY
  useEffect(() => {
    if (id_permintaan_produksi) {
      PermintaanBahanProduksiApi.transfer({
        id_permintaan_produksi,
        ref_bahan: 'bfs',
      })
        .then((res) => setHistory(res.data.data ?? []))
        .catch(({ response }) =>
          alert(
            `Gagal memuat data History Factory Supply ${response.data.message}`
          )
        );
    }
  }, [id_permintaan_produksi]);

  return (
    <Fragment>
      <Row className="d-flex justify-content-between align-items-end mb-1">
        <Col>
          <small>List Data Permintaan Factory Supply</small>
        </Col>
      </Row>
      <TablePermintaanFS data={dataPermintaan?.factory ?? []} />

      <small className="mt-2">List Data Transfer Bahan Produksi</small>
      <TableTransferBahanProduksi
        tipe="editable"
        tipeTransfer="factory"
        data={dataPermintaan?.factory}
        uniqueKey="id_permintaan_produksi_finishing"
      />

      <small className="mt-2">History Transfer Bahan Produksi</small>
      <TableTransferBahanProduksi tipe="readonly" data={history} />
    </Fragment>
  );
};
